<div class="container">
    
    <h1>Profil</h1>
    <p> {{user.username}}</p>
    <p> {{user.email}}</p>
   
</div>
<div class="container">
    
    <h1>Mes Quizz</h1>
    <div *ngFor="let quiz of quizList"  >
        <app-quiz class="quiz" [quiz]="quiz"></app-quiz>
    </div>
   
</div>
